import styled from '@emotion/styled';

import { COLORS3, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';

// components
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

export const StyledFacetBtn = styled(ButtonV3)`
  ${FONT.textSizeUltraCompact(FONT.SIZE.SMALLER)}
  background-color: ${COLORS3.BLACK_005};
  color: ${COLORS3.BLACK_100};
  font-weight: ${FONT.WEIGHT.MEDIUM};

  &:hover, &:focus {
    background-color: ${COLORS3.BLACK_005};
    color: ${COLORS3.BLACK_100};
  }

  span {
    margin-left: ${SPACING.XS};
    white-space: nowrap;
  }
`;
